import { AppMessages } from 'i18n/messages';
import { useLocale } from 'hooks/useLocale/useLocale';
import {
  CardsQueryKeysEnum,
  QueryKeyLocalStorageEnum,
  WantedIdSortEnum,
  WantedOwnerNameSortEnum,
  WantedOwnerRegistrationNumberSortEnum,
} from 'context/query/queryContext/QueryContext.enum';
import { Table } from 'ui/table/Table';
import { OrganizationsTreeSelect } from 'ui/organizationsTreeSelect/OrganizationsTreeSelect';
import { useLocaleStoreQuery } from 'hooks/useLocaleStoreQuery/useLocaleStoreQuery';
import { ProblemTkdDescriptionEnum } from 'api/cards/cards.enum';

import * as Styled from './WantedTableHeader.styles';

export const WantedTableHeader = () => {
  const { formatMessage } = useLocale();

  const {
    storedQueries: { [QueryKeyLocalStorageEnum.WANTED]: wantedQuery },
    setQuery,
  } = useLocaleStoreQuery();

  const setWantedQuery = (updatedWantedQuery: Partial<typeof wantedQuery>) => {
    setQuery(QueryKeyLocalStorageEnum.WANTED, {
      ...wantedQuery,
      ...updatedWantedQuery,
    });
  };

  const problemTkdFilterOptions = [
    {
      name: formatMessage({ id: AppMessages[ProblemTkdDescriptionEnum.true] }),
      filterBy: 'true',
    },
    {
      name: formatMessage({ id: AppMessages[ProblemTkdDescriptionEnum.false] }),
      filterBy: 'false',
    },
  ];

  return (
    <>
      <Table.HeaderSortItem
        queryKey={QueryKeyLocalStorageEnum.WANTED}
        sortBy={WantedIdSortEnum}
        queryHeader={formatMessage({ id: AppMessages['wanted.random.table.id'] })}
      />

      <Table.HeaderSortItem
        queryKey={QueryKeyLocalStorageEnum.WANTED}
        sortBy={WantedOwnerNameSortEnum}
        queryHeader={formatMessage({ id: AppMessages['wanted.random.table.name'] })}
      />

      <Table.HeaderFilterItem
        queryKey={QueryKeyLocalStorageEnum.WANTED}
        queryName={CardsQueryKeysEnum.PROBLEM_TKD}
        filterItems={problemTkdFilterOptions}
        queryHeader={formatMessage({ id: AppMessages['wanted.random.table.reader'] })}
        queryHeaderDescriptions={ProblemTkdDescriptionEnum}
        headerWrapper={(header) => <Styled.ProblemTkdHeaderText noWrap>{header}</Styled.ProblemTkdHeaderText>}
      />

      <OrganizationsTreeSelect
        multiple
        isFilterType
        onChange={(options) =>
          options &&
          setWantedQuery({
            komorka: options.map((cell) => cell.id),
          })
        }
        value={wantedQuery.komorka?.map((id) => ({ id, nazwa: 'komorka' }))}
        placeholder={formatMessage({ id: AppMessages['wanted.random.table.cell'] })}
      />

      <Table.HeaderSortItem
        queryKey={QueryKeyLocalStorageEnum.WANTED}
        sortBy={WantedOwnerRegistrationNumberSortEnum}
        queryHeader={formatMessage({ id: AppMessages['wanted.random.table.registrationNumber'] })}
      />
    </>
  );
};
